import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export function MarketingHeader() {
  const { t } = useTranslation("common");

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 px-6 py-4 transition-all border-b border-black bg-white/80 backdrop-blur-md dark:border-white/20 dark:bg-black/80">
      <div className="flex items-center justify-between mx-auto max-w-7xl">
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <img
            src="https://res.cloudinary.com/dk9mn4cvz/image/upload/v1772836238/Clawcraft-Logo-AI-Agents_ahopwf.svg"
            alt="Clawcraft Logo"
            className="h-[22px] w-auto dark:invert"
          />
        </Link>

        <div className="hidden items-center gap-8 text-[15px] font-medium text-black/70 md:flex dark:text-white/70">
          <a
            href="/#features"
            className="transition-colors hover:text-brand-coral-dark dark:hover:text-brand-coral"
          >
            {t("nav.features")}
          </a>
          <a
            href="/#how-it-works"
            className="transition-colors hover:text-brand-coral-dark dark:hover:text-brand-coral"
          >
            {t("nav.howItWorks")}
          </a>
          <a
            href="/#pricing"
            className="transition-colors hover:text-brand-coral-dark dark:hover:text-brand-coral"
          >
            {t("nav.pricing")}
          </a>
        </div>

        <div className="flex items-center gap-3">
          <Link
            to="/login"
            search={{ pendingCode: undefined }}
            className="rounded-full border border-black px-5 py-2.5 text-[15px] font-semibold text-black transition-all hover:-translate-y-px hover:bg-black hover:text-white dark:border-white/20 dark:text-white dark:hover:bg-white dark:hover:text-black"
          >
            {t("nav.login")}
          </Link>
          <a
            href="https://tally.so/r/WOoqzv"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden rounded-full border border-black bg-brand-coral-dark px-5 py-2.5 text-[15px] font-semibold text-white transition-all hover:-translate-y-px hover:bg-brand-coral sm:block dark:border-white/20"
          >
            {t("nav.apply")}
          </a>
        </div>
      </div>
    </nav>
  );
}
